/*
 * The sports' pictures on the VIP sports page: the three scenes of the classic
 * home's sport card, standing still, hockey drawn to match, and a small ball
 * for each of the other sports. Coloured with the theme accent.
 */

/** One sheet of gradients the pictures share; rendered once per page. */
export const VipArtDefs = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
    <defs>
      <radialGradient id="vipBallW" cx=".35" cy=".3" r=".75">
        <stop offset="0" stopColor="#fff" />
        <stop offset=".7" stopColor="#e3e8ef" />
        <stop offset="1" stopColor="#9aa4b2" />
      </radialGradient>
      <radialGradient id="vipBallO" cx=".35" cy=".3" r=".8">
        <stop offset="0" stopColor="#ffc07a" />
        <stop offset=".55" stopColor="#f07a1c" />
        <stop offset="1" stopColor="#9c3f08" />
      </radialGradient>
      <radialGradient id="vipBallT" cx=".35" cy=".3" r=".8">
        <stop offset="0" stopColor="#f6ff9a" />
        <stop offset=".6" stopColor="#cde33a" />
        <stop offset="1" stopColor="#7f951a" />
      </radialGradient>
      <linearGradient id="vipPost" x1="0" x2="1">
        <stop offset="0" stopColor="#fff" />
        <stop offset="1" stopColor="#c3cad4" />
      </linearGradient>
      <linearGradient id="vipFrame" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#f4f6fa" />
        <stop offset=".5" style={{ stopColor: 'var(--vip-acc)' }} />
        <stop offset="1" stopColor="#3a4150" />
      </linearGradient>
      <linearGradient id="vipGlass" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#ffffff40" />
        <stop offset="1" stopColor="#ffffff0a" />
      </linearGradient>
      <pattern id="vipNet" width="6" height="6" patternUnits="userSpaceOnUse">
        <path d="M0 0L6 6M6 0L0 6" stroke="#ffffff55" strokeWidth=".6" />
      </pattern>
      <pattern id="vipStr" width="4" height="4" patternUnits="userSpaceOnUse">
        <path d="M0 0H4M0 0V4" stroke="#ffffffaa" strokeWidth=".5" />
      </pattern>
      <clipPath id="vipHead">
        <ellipse cx="120" cy="50" rx="13" ry="18" />
      </clipPath>
    </defs>
  </svg>
);

const scene = (art: JSX.Element) => (
  <svg viewBox="0 0 180 124" aria-hidden="true">
    {art}
  </svg>
);

export const FootballArt = () =>
  scene(
    <g>
      <path d="M14 94h152" stroke="#ffffff30" strokeWidth="1" />
      <g>
        <path d="M66 38h70v54H66z" fill="url(#vipNet)" />
        <path
          d="M54 28l12 10v54M146 28l-10 10v54M66 38h70"
          stroke="#ffffff70"
          strokeWidth="1"
          fill="none"
        />
        <path
          d="M54 28L66 38V92H54zM146 28l-10 10v54h10z"
          fill="url(#vipNet)"
          opacity=".8"
        />
      </g>
      <path
        d="M54 94V28h92v66"
        fill="none"
        stroke="url(#vipPost)"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      <ellipse cx="112" cy="94" rx="9" ry="2" fill="#0008" />
      <g>
        <circle cx="112" cy="70" r="9" fill="url(#vipBallW)" />
        <path d="M112 64.3l4.4 3.2-1.7 5.2h-5.4l-1.7-5.2z" fill="#1d2330" />
        <path
          d="M103.6 67.5l2.4.7M120.4 67.5l-2.4.7M106.8 77.3l1.6-2.6M117.2 77.3l-1.6-2.6M112 61v3.3"
          stroke="#1d2330"
          strokeWidth="1.6"
        />
      </g>
    </g>
  );

export const BasketballArt = () =>
  scene(
    <g>
      <path d="M14 104h152" stroke="#ffffff22" strokeWidth="1" />
      <path d="M150 20v84" stroke="#59606d" strokeWidth="4" />
      <rect
        x="106"
        y="14"
        width="46"
        height="32"
        rx="3"
        fill="url(#vipGlass)"
        stroke="#e9edf3"
        strokeWidth="2.5"
      />
      <rect
        x="121"
        y="26"
        width="16"
        height="12"
        fill="none"
        style={{ stroke: 'var(--vip-acc)' }}
        strokeWidth="2"
      />
      <path
        d="M112 52l3 18h14l3-18M112 52l6 6-3 6 4 6M132 52l-6 6 3 6-4 6M118 52l4 6 4-6M115 64h14"
        fill="none"
        stroke="#ffffffb0"
        strokeWidth="1"
      />
      <ellipse
        cx="122"
        cy="52"
        rx="11"
        ry="3"
        fill="none"
        stroke="#ff6a13"
        strokeWidth="3"
      />
      <g>
        <circle cx="122" cy="44" r="9" fill="url(#vipBallO)" />
        <path d="M113 44h18M122 35v18" stroke="#4a1f05" strokeWidth="1.1" />
        <path
          d="M115.2 37.8c3.8 3.6 3.8 8.8 0 12.4M128.8 37.8c-3.8 3.6-3.8 8.8 0 12.4"
          stroke="#4a1f05"
          strokeWidth="1.1"
          fill="none"
        />
      </g>
    </g>
  );

export const TennisArt = () =>
  scene(
    <g>
      <path d="M14 100h152" stroke="#ffffff40" strokeWidth="1.2" />
      <path
        d="M30 86h120"
        stroke="#ffffff55"
        strokeWidth="1"
        strokeDasharray="2 2"
      />
      <path d="M30 86v14M150 86v14" stroke="#cfd5de" strokeWidth="2" />
      <g>
        <ellipse
          cx="120"
          cy="50"
          rx="13"
          ry="18"
          fill="url(#vipStr)"
          clipPath="url(#vipHead)"
        />
        <ellipse
          cx="120"
          cy="50"
          rx="14"
          ry="19"
          fill="none"
          stroke="url(#vipFrame)"
          strokeWidth="4"
        />
        <path
          d="M114 67l6 10 6-10"
          fill="none"
          stroke="url(#vipFrame)"
          strokeWidth="3"
          strokeLinejoin="round"
        />
        <rect
          x="117.5"
          y="76"
          width="5"
          height="22"
          rx="2"
          fill="#1d222c"
          stroke="#ffffff30"
        />
        <path
          d="M117.5 80l5 2M117.5 85l5 2M117.5 90l5 2"
          stroke="#ffffff40"
          strokeWidth="1"
        />
      </g>
      <g>
        <circle cx="100" cy="50" r="6" fill="url(#vipBallT)" />
        <path
          d="M95 47.5c3 2.2 7 2.2 10 0M95 52.5c3-2.2 7-2.2 10 0"
          stroke="#fffde8"
          strokeWidth="1"
          fill="none"
        />
      </g>
    </g>
  );

export const HockeyArt = () =>
  scene(
    <>
      <path d="M14 100h152" stroke="#ffffff30" />
      <path
        d="M30 108c30-22 60-20 120 0"
        fill="none"
        stroke="var(--vip-acc)"
        strokeOpacity=".35"
        strokeWidth="1.5"
      />
      <path
        d="M126 14L78 92"
        stroke="#c98a4a"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <path d="M112 37l-9 14" stroke="#1d2330" strokeWidth="7" />
      <path d="M80 89L72 100H44c-5 0-5-8 0-8z" fill="#e9edf3" />
      <ellipse cx="114" cy="98" rx="15" ry="5" fill="#0b0d12" />
      <ellipse cx="114" cy="94" rx="15" ry="5" fill="#2a2f3a" />
    </>
  );

const RUGBY = (
  <>
    <ellipse
      cx="24"
      cy="24"
      rx="21"
      ry="13"
      transform="rotate(-32 24 24)"
      fill="url(#vipBallW)"
    />
    <path d="M12 33L36 15" stroke="#7d8798" strokeWidth="1.4" />
  </>
);

/** By sport id, the feed's numbers. */
const BALLS: Record<number, JSX.Element> = {
  91: (
    <>
      <circle cx="24" cy="24" r="17" fill="url(#vipBallW)" />
      <path
        d="M24 7c-2 9 1 17 8 22M41 26c-9-3-17-1-23 5M12 36c-1-10 3-18 11-22M9 16c8 3 14 3 21-2M33 39c1-7-1-12-5-16"
        fill="none"
        stroke="#7d8798"
        strokeWidth="1.4"
      />
    </>
  ),
  78: (
    <>
      <circle cx="24" cy="24" r="17" fill="url(#vipBallO)" />
      <path
        d="M24 7v34M7 24c6-5 12-5 17 0s11 5 17 0M12 12c5 6 5 18 0 24M36 12c-5 6-5 18 0 24"
        fill="none"
        stroke="#5e2605"
        strokeWidth="1.3"
        opacity=".75"
      />
    </>
  ),
  12: (
    <>
      <ellipse
        cx="24"
        cy="24"
        rx="21"
        ry="12.5"
        transform="rotate(-32 24 24)"
        fill="#8a4a22"
      />
      <path d="M15 31l18-14" stroke="#fff" strokeWidth="1.8" />
      <path
        d="M20 24l3 4M23 22l3 4M26 19l3 4"
        stroke="#fff"
        strokeWidth="1.6"
      />
    </>
  ),
  16: (
    <>
      <circle cx="24" cy="24" r="17" fill="url(#vipBallW)" />
      <path
        d="M14 10c6 9 6 19 0 28M34 10c-6 9-6 19 0 28"
        fill="none"
        stroke="#d3373c"
        strokeWidth="1.6"
        strokeDasharray="2.4 2"
      />
    </>
  ),
  162: (
    <>
      <path
        d="M15 6h18l10 10v16L33 42H15L5 32V16z"
        fill="none"
        stroke="var(--vip-acc)"
        strokeWidth="2"
      />
      <path
        d="M17 20c0-5 14-5 15-1l1 9c0 4-3 6-7 6h-5c-3 0-5-2-4-5z"
        fill="#d3373c"
      />
      <path d="M18 29h14" stroke="#fff" strokeWidth="2" />
    </>
  ),
  15: (
    <>
      <circle
        cx="24"
        cy="24"
        r="19"
        fill="#15171c"
        stroke="var(--vip-acc)"
        strokeWidth="2"
      />
      <circle
        cx="24"
        cy="24"
        r="12"
        fill="none"
        stroke="#d3373c"
        strokeWidth="3"
      />
      <circle cx="24" cy="24" r="4" fill="#3fae6a" />
    </>
  ),
  92: (
    <>
      <circle cx="20" cy="19" r="13" fill="#d3373c" />
      <path
        d="M29 28l11 11"
        stroke="#c98a4a"
        strokeWidth="6"
        strokeLinecap="round"
      />
      <circle cx="37" cy="13" r="5" fill="#fff" />
    </>
  ),
  8: RUGBY,
  19: RUGBY,
  110: (
    <>
      <circle cx="24" cy="24" r="17" fill="#f2c230" />
      <path
        d="M8 18c9 4 23 4 32 0M9 31c9-4 21-4 30 0M24 7v34"
        fill="none"
        stroke="#7a5a08"
        strokeWidth="1.3"
        opacity=".7"
      />
    </>
  ),
};

/** A small picture of the sport; null when none is drawn for it. */
export const SportBall = ({ sportId }: { sportId: number }) =>
  BALLS[sportId] ? (
    <svg viewBox="0 0 48 48" aria-hidden="true">
      {BALLS[sportId]}
    </svg>
  ) : null;
